import * as React from 'react';
import { Link } from 'react-router-dom';
import { Groups } from '../../../Enum/Groups';
import { FilterInterface } from '../../../Filter/FilterInterface';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { FilterService } from '../../../Service/FilterService';
import { Trans } from '../../Trans';
import { AbstractFinder, FinderProps } from '../AbstractFinder';

export interface AmplifierFinderProps extends FinderProps {
}

export class AmplifierFinder extends AbstractFinder<AmplifierFinderProps> {
    get group(): Groups {
        return Groups.Amplifier;
    }

    protected renderHeadline(filteredProducts: ProductInterface[], allProducts: ProductInterface[]): JSX.Element {
        return <h1>
            <Link to="/">Home</Link> &gt; <Trans>Messverstärker</Trans>
        </h1>;
    }

    protected getInitialFilters(): FilterInterface<any>[] {
        return [
            FilterService.equals('Technologie', '', false),
            FilterService.oneOf('Feldbus', [], false),

            FilterService.callback('Schutzart', [], this.filterProtectionClass, false),
            FilterService.equals('Anzahl_Kanaele', '', false),
            FilterService.equals('Anzahl_Kraftaufnehmer', '', false),
            FilterService.callback('analogOutput', [], this.filterAnalogOutput, false),
        ];
    }

    protected renderFooter(
        rootProducts: ProductInterface[],
        filteredProducts: ProductInterface[],
        allProducts: ProductInterface[]
    ): JSX.Element | null {
        return <div className="pf-finder-footer">
            {/*<ul>*/}
            {/*    <li><strong><code>A_PIM_Anzahl_Messstellen</code></strong> nicht gefunden</li>*/}
            {/*</ul>*/}
        </div>;
    }

    protected collectProducts(rootProducts: ProductInterface[]): ProductInterface[] {
        return rootProducts;
    }

    private filterAnalogOutput(product: ProductInterface, values: string[]): boolean {
        if (values.length === 0) {
            return true;
        }
        const currentOutput = AttributeUtility.attributeForKey(product, 'Stromausgang');
        const voltageOutput = AttributeUtility.attributeForKey(product, 'Spannungsausgang');

        return (typeof currentOutput !== 'undefined' && -1 < values.indexOf(currentOutput.displayString))
            || (typeof voltageOutput !== 'undefined' && -1 < values.indexOf(voltageOutput.displayString));
    }

    private filterProtectionClass(product: ProductInterface, values: string[]): boolean {
        if (values.length === 0) {
            return true;
        }

        const attributes = AttributeUtility.attributesForKeyFiltered(product.children, 'Schutzart');
        for (const attribute of attributes) {
            if (values.includes(attribute.displayString)) {
                return true;
            }
        }
        return false;
    }
}
